// ccms-yii2-tsmd: tsmd\base\user\models\User::ROLE_ADMIN = 9.
// ROLE_ADMCC (8) is a different role and cannot call labelcc password APIs.
export function canManageAccountPasswords (user = {}) {
  return String(user.role) === '9' &&
    typeof user.label === 'string' && user.label.length > 0 && user.label !== 'all'
}



// WEBPACK FOOTER //
// ./src/utils/permissions.js